import { Wrapper } from 'lib/noop-wrapper'
import React from 'react'
import Link from 'next/link'

interface ICommunityLink {
  id?: string
}

function communityLink({ id }: ICommunityLink): Wrapper {
  return (content) =>
    id ? (
      <React.Fragment>
        <Link href={`/community/${id}`} as={`/community/${id}`}>
          <a target={'_blank'}>{content}</a>
        </Link>
        <style jsx>
          {`
            a {
              color: inherit;
            }
          `}
        </style>
      </React.Fragment>
    ) : (
      content
    )
}

export default communityLink
